import React from 'react';
import cacheRequests from './cacheRequests';

const _myVar = {};
_myVar.NODE_ENV = typeof env !== 'undefined' ? env.NODE_ENV : global.process.env.NODE_ENV;// eslint-disable-line no-undef
_myVar.PORT = typeof env !== 'undefined' ? env.PORT : global.process.env.PORT;// eslint-disable-line no-undef
const MY_VAR = typeof window !== 'undefined' ? window.env : (_myVar);

export default class FlushCache extends React.Component {

  state = {}

  flushEverything = () => {
    cacheRequests.flushcache(undefined, (response) => {
      this.setState({
        response,
      });
    });
  }

  render() {
    return (
      <React.Fragment>
        <script dangerouslySetInnerHTML={{ __html: 'env = ' + (JSON.stringify(MY_VAR)) + '' }} />
        <div className="container">
          <div className="main">
            {
              this.state.response && this.state.response.error &&
              <div className="error">
                Error occured while flushing cache.
                        </div>
            }
            {
              this.state.response && this.state.response.data &&
              <div className="error">
                Cache flushed successfully.
                        </div>
            }
            <button type="button" onClick={this.flushEverything}>FLUSH COHERENCE CACHE</button>
          </div>
        </div>
      </React.Fragment >
    );
  }
}
